import BILLTECH from './billtech';
import { toTailwindCompatibleChannels } from './utils';

export const themes: IThemes = {
  BILLTECH
};

export enum THEMES {
  BILLTECH = 'BILLTECH'
}

export const DEFAULT_THEME = THEMES.BILLTECH;

export const CURRENT_THEME_HOLDER = {
  currentTheme: DEFAULT_THEME
};

export interface ITheme {
  [key: string]: string;
}

export interface IThemes {
  [key: string]: ITheme;
}

export interface IMappedTheme {
  [key: string]: string | null;
}

export const mapTheme = (variables: ITheme): IMappedTheme => {
  if (!variables) {
    return null;
  }
  return Object.entries(variables).reduce(
    (acc, [key, value]) => ({ ...acc, [`--color-primary-${key}`]: toTailwindCompatibleChannels(value) }),
    {
      ['--color-primary']: variables[600]
    }
  );
};

export const applyTheme = (theme: THEMES): void => {
  const themeObject: IMappedTheme = mapTheme(themes[theme]);
  if (!themeObject) {
    return;
  }

  CURRENT_THEME_HOLDER.currentTheme = theme;

  const root = document.documentElement;

  Object.keys(themeObject).forEach(property => {
    if (property === 'name') {
      return;
    }

    root.style.setProperty(property, themeObject[property]);
  });
};
